import { render, staticRenderFns } from "./SelfPublishingFlowQuoteFooterLaBoutiqueSoBook.vue?vue&type=template&id=3558acd6&scoped=true&"
import script from "./SelfPublishingFlowQuoteFooterLaBoutiqueSoBook.vue?vue&type=script&lang=js&"
export * from "./SelfPublishingFlowQuoteFooterLaBoutiqueSoBook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3558acd6",
  null
  
)

export default component.exports